// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mc-mentor-modal .mc-modal{top:14%}.mc-mentor-modal *{box-sizing:content-box}", ""]);
// Exports
module.exports = exports;
